import { dataUserTieba } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserTieba = /*#__PURE__*/createIcon(dataUserTieba)
export default IconUserTieba
